// WORK SCHEDULE PAGE

import {
  CHOICE_DRIVER_TYPE,
  DR_DRIVER_TYPE,
  ODF_DRIVER_TYPE,
  ROBOT_DRIVER_TYPE,
} from "./driverTypes";

export const daysOfWeek = [1, 2, 3, 4, 5, 6, 0];

// DRIVER PROFILE PAGE
export const phoneNumberRegex = new RegExp(
  "^[0]?([1-6][0-9]{8,10}|7[0-9]{9})$"
);

export const buildDriverTypeCodeRegex = (driverPrefixes, driverType) => {
  if (!driverPrefixes) return new RegExp(``);

  const typePrefixes = driverPrefixes.filter(
    (prefix) => prefix.driverType === driverType
  );
  return new RegExp(
    `^([0-9]{4})\\*(?:${typePrefixes
      .map(({ prefixCode }) => `${[prefixCode]}`)
      .join("|")})[0-9]{1,10}$`
  );
};

export const getDriverCodeRegexes = (driverPrefixes) => ({
  odfDriverCodeRegex: buildDriverTypeCodeRegex(driverPrefixes, ODF_DRIVER_TYPE),
  drDriverCodeRegex: buildDriverTypeCodeRegex(driverPrefixes, DR_DRIVER_TYPE),
  robotDriverCodeRegex: buildDriverTypeCodeRegex(
    driverPrefixes,
    ROBOT_DRIVER_TYPE
  ),
  choiceDriverCodeRegex: buildDriverTypeCodeRegex(
    driverPrefixes,
    CHOICE_DRIVER_TYPE
  ),
});

export const newDriverCodeRegex = new RegExp("^([0-9]{4})[*][A-Z0-9]+$");
